/* global axios */

import ApiClient from './ApiClient';

class KnowledgeBaseAPI extends ApiClient {
  constructor() {
    super('knowledge_bases', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }
}

export default new KnowledgeBaseAPI();
